var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.responsiveLayout
    ? _c("div", { staticClass: "responsive-wrapper" }, [
        _c(
          "button",
          {
            class: ["app-button-" + _vm.variant, _vm.computedButtonClasses],
            attrs: {
              type: "button",
              disabled: _vm.disabled || _vm.loading,
              "aria-label": _vm.ariaLabel,
              "aria-expanded": _vm.ariaExpanded,
              "aria-controls": _vm.ariaControls,
            },
            on: { click: _vm.handleClick },
          },
          [
            _vm.loading
              ? [
                  _c(
                    "svg",
                    {
                      staticClass: "tw-animate-spin tw-h-4 tw-w-4 tw-mr-2",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                      },
                    },
                    [
                      _c("circle", {
                        staticClass: "tw-opacity-25",
                        attrs: {
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "tw-opacity-75",
                        attrs: {
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.loadingText || _vm.displayText)),
                  ]),
                ]
              : [
                  _vm.displayIcon
                    ? _c("i", {
                        class: _vm.displayIcon,
                        staticStyle: {
                          display: "inline-flex",
                          "align-items": "center",
                        },
                        attrs: { "aria-hidden": "true" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      style: _vm.displayIcon
                        ? "margin-left: 0.5rem; display: inline-flex; align-items: center;"
                        : "",
                    },
                    [_vm._v(_vm._s(_vm.displayText))]
                  ),
                ],
          ],
          2
        ),
      ])
    : _c(
        "button",
        {
          class: _vm.computedButtonClasses,
          style: _vm.buttonInlineStyles,
          attrs: {
            type: "button",
            disabled: _vm.disabled || _vm.loading,
            "aria-label": _vm.ariaLabel,
            "aria-expanded": _vm.ariaExpanded,
            "aria-controls": _vm.ariaControls,
          },
          on: { click: _vm.handleClick },
        },
        [
          _vm.loading
            ? [
                _c(
                  "svg",
                  {
                    staticClass: "tw-animate-spin tw-h-4 tw-w-4 tw-mr-2",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24",
                    },
                  },
                  [
                    _c("circle", {
                      staticClass: "tw-opacity-25",
                      attrs: {
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticClass: "tw-opacity-75",
                      attrs: {
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.loadingText || _vm.displayText)),
                ]),
              ]
            : [
                _vm.displayIcon
                  ? _c("i", {
                      class: _vm.displayIcon,
                      attrs: { "aria-hidden": "true" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    class: [
                      _vm.displayIcon ? "tw-ml-2" : "",
                      _vm.disabled || _vm.loading ? "disabled-text" : "",
                    ],
                  },
                  [_vm._v(_vm._s(_vm.displayText))]
                ),
              ],
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }